import api from './api';

export async function getEquipments() {
  const { data } = await api.get('/equipment');
  return data;
}

export async function createEquipment(payload) {
  const { data } = await api.post('/equipment', payload);
  return data;
}

export async function updateEquipment(id, payload) {
  const { data } = await api.put(`/equipment/${id}`, payload);
  return data;
}

export async function deleteEquipment(id) {
  const { data } = await api.delete(`/equipment/${id}`);
  return data;
}

export async function getBranchEquipment(branchId) {
  const { data } = await api.get(`/branch-equipment/branch/${branchId}`);
  return data;
}

export async function createBranchEquipment(payload) {
  const { data } = await api.post('/branch-equipment', payload);
  return data;
}

export async function updateBranchEquipment(id, payload) {
  const { data } = await api.put(`/branch-equipment/${id}`, payload);
  return data;
}

export async function deleteBranchEquipment(id) {
  const { data } = await api.delete(`/branch-equipment/${id}`);
  return data;
}
